export default "__VITE_ASSET__00Qne3an__"